import React, { Component } from 'react';
import PropsType from 'prop-types';
import { Toast } from 'antd-mobile';
import Http from '../../config/axiosUtils';

import './IncomeFilter.scss';

class IncomeFilter extends Component {
  state = {
    sourceList: [],
    typeList: [],
    source: '',
    type: '',
    sourceIndex: 0,
    typeIndex: 0
  }

  componentDidMount() {
    this.fetchType();
    this.fetchSource();
  }

  fetchType = async () => {
    const path = '/spread/web/income/incomeTypeList';
    const res = await Http.get(path);
    if (res.code === 0) {
      this.setState({
        typeList: res.data,
      }, () => {
        const typeKey = this.props.defaultFilter.incomeType;
        if (typeKey) {
          this.state.typeList.forEach((item, index) => {
            if (typeKey === item.code) {
              this.setState({
                typeIndex: index + 1,
                type: item.code
              })
            }
          })
        } else {
          this.setState({
            typeIndex: 0,
            type: ''
          })
        }
      });
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  fetchSource = async () => {
    const path = '/spread/web/income/incomeSourceTypeList';
    const res = await Http.get(path);
    if (res.code === 0) {
      this.setState({
        sourceList: res.data,
      }, () => {
        const sourceKey = this.props.defaultFilter.incomeSourceType;
        if (sourceKey) {
          this.state.sourceList.forEach((item, index) => {
            if (sourceKey === item.code) {
              this.setState({
                sourceIndex: index + 1,
                source: item.code
              })
            }
          })
        } else {
          this.setState({
            sourceIndex: 0,
            source: ''
          })
        }
      });
    } else {
      Toast.fail(res.msg, 2);
    }
  }
  
  //选择类型来源
  selectFunc = (key1, key2, code, index) => {
    this.setState({
      [key1]: code,
      [key2]: index
    });
  }

  //重置
  reset = () => {
    this.setState({
      source: '',
      type: '',
      sourceIndex: 0,
      typeIndex: 0
    })
    this.props.filterConfirm('', '');
  }

  confirm = () => {
    this.props.filterConfirm(this.state.type, this.state.source);
  }

  render () {
    const { typeIndex, sourceIndex, typeList, sourceList } = this.state;
    return (
      <div className='incomeFilter mask'>
        <div className='filter'>
          <div className='title'>筛选<span onClick={this.props.closeFilter}>取消</span></div>
          <div className='content'>
            <div>收益类型</div>
            <ul>
              <li className={typeIndex === 0 ? 'high' : ''} onClick={this.selectFunc.bind(this, 'type', 'typeIndex', '', 0)}>全部</li>
              {
                typeList.map((item, index) => {
                  return (
                    <li className={typeIndex === index + 1 ? 'high' : ''} key={index} onClick={this.selectFunc.bind(this, 'type', 'typeIndex', item.code, index + 1)}>{item.value}</li>
                  )
                })
              }
            </ul>
          </div>
          <div className='content'>
            <div>收益来源</div>
            <ul>
              <li className={sourceIndex === 0 ? 'high' : ''} onClick={this.selectFunc.bind(this, 'source', 'sourceIndex', '', 0)}>全部</li>
              {
                sourceList.map((item, index) => {
                  return (
                    <li className={sourceIndex === index + 1 ? 'high' : ''} key={index} onClick={this.selectFunc.bind(this, 'source', 'sourceIndex', item.code, index + 1)}>{item.value}</li>
                  )
                })
              }
            </ul>
          </div>
          <div className='btn'>
            <div onClick={this.reset}>重置</div>
            <div onClick={this.confirm}>确定</div>
          </div>
        </div>
      </div>
    )
  }
}

IncomeFilter.propsType = {
  closeFilter: PropsType.func,
  filterConfirm: PropsType.func,
  defaultFilter: PropsType.object
}

export default IncomeFilter;